/**
 * Where a folder lives, by ID.
 *
 * Its own module because the rail, the chips and the palette all navigate, and
 * routing them through the route component makes a cycle out of what is one
 * string. By id and never by name: 12 of the 33 folder names are also held by
 * an ordinary tag, and two folders may share a name under different parents.
 */
export function folderHref(id: string): string {
  return `/folders/${encodeURIComponent(id)}`;
}

export function fileHref(path: string): string {
  return `/file/${path.split('/').map(encodeURIComponent).join('/')}`;
}
